import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DistributeJustifiedV } from '../icons';
import { ToolbarButton } from '../ui';
import { getAlignToContainer, getSelectedObjectsIDs } from '../editor';
import { getCurrentPiece, distributeObjectsJustifiedV } from '../project';

const ButtonDistributeJustifiedV = ({ disabled, onClick }) => {
  if (disabled) {
    return null;
  }

  return <ToolbarButton icon={<DistributeJustifiedV />} onClick={onClick} />;
};

ButtonDistributeJustifiedV.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const reduxConnector = connect(
  state => {
    let container = getCurrentPiece(state);
    if (!getAlignToContainer(state)) {
      container = null;
    }

    const ids = getSelectedObjectsIDs(state);
    let disabled = true;
    if (ids.size >= 2) {
      disabled = false;
    }
    return { ids, disabled, container };
  },
  { distributeObjectsJustifiedV },
  ({ ids, container, ...state }, actions) => ({
    ...state,
    onClick: () => actions.distributeObjectsJustifiedV({ ids, container }),
  }),
);

export default reduxConnector(ButtonDistributeJustifiedV);
